"use strict";
// (C) 2020-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightRenderer = exports.InsightError = exports.InsightView = void 0;
var InsightView_1 = require("./InsightView");
Object.defineProperty(exports, "InsightView", { enumerable: true, get: function () { return InsightView_1.InsightView; } });
// exports only for internal use by other gooddata packages
var InsightError_1 = require("./InsightError");
Object.defineProperty(exports, "InsightError", { enumerable: true, get: function () { return InsightError_1.InsightError; } });
var InsightRenderer_1 = require("./InsightRenderer");
Object.defineProperty(exports, "InsightRenderer", { enumerable: true, get: function () { return InsightRenderer_1.InsightRenderer; } });
//# sourceMappingURL=index.js.map